module.exports = __webpack_public_path__ + "img/form3.d9318c14.png";